// Importing specific icons from react-icons/fa
import {
  FaUsers,
  FaUserPlus,
  FaUserAlt,
  FaUserTie,
  FaQuestion,
  FaCheckDouble,  
} from "react-icons/fa";

// Importing specific icons from react-icons/md
import {
  MdWork,
  MdBusinessCenter,
  MdSchool,
  MdTask,
  MdOutlineQuestionAnswer,
  MdQuestionAnswer,
  MdListAlt,
  MdTimer,
  MdList,
  MdDashboard,
  MdLabel,
  MdFavorite,
} from "react-icons/md";

import { IconType } from "react-icons";

// Restricted icon mapping
const iconMap: { [key: string]: IconType } = {
  FaUsers,
  FaUserPlus,
  FaUserAlt,
  FaUserTie,
  FaQuestion,
  FaCheckDouble,
  MdWork,
  MdBusinessCenter,
  MdSchool,
  MdTask,
  MdOutlineQuestionAnswer,
  MdListAlt,
  MdTimer,
  MdList,
  MdQuestionAnswer,
  MdDashboard,
  MdLabel,
  MdFavorite,
};

// Function to get the icon based on the name
export const getIcon = (iconName: string): IconType | null => {
  return iconMap[iconName] || null;
};
